import { useLocation } from 'react-router';

export default function useGetUrlParam(param: string) {
  const queryParams = useLocation().search;
  let paramValue = new URLSearchParams(queryParams).get(param);

  if (!paramValue) return '';

  if (param === 'email') {
    // replace @ symbol if email is url encoded and replace spaces for + in case email
    // is test+one@alitu.com
    paramValue = paramValue?.replace('%40', '@').replace(/\s/g, '+');
  }
  return paramValue;
}
